import {
    getPromotionAPI,
    getNoticeListAPI,
    getNoticeDetailAPI,
} from '@/api/notice'
import { toRaw } from 'vue'

const notice = {
    namespaced: true,
    state: () => ({
        promotionItem: {}, // 促销活动通知个项
        promotions: {
            list: [],
            total: 0,
        }, // 促销活动通知
    }),
    mutations: {
        /* 设置促销活动通知 */
        setPromotions(state, promotions) {
            state.promotions = {...promotions }
        },
    },
    actions: {
        /* 获取促销活动通知 */
        async fetchPromotion({ commit }, data) {
            const res = await getPromotionAPI(data)

            commit('setPromotions', res)

            return res
        },
        /* 获取通知列表 */
        async fetchNoticeList({ commit }, data) {
            const res = await getNoticeListAPI(data)
            commit('setNoticeList', res)
            return res
        },

        /* 获取通知详情 */
        async fetchNoticeDetail({ commit }, id) {
            const res = await getNoticeDetailAPI(id)
            commit('setNoticeDetail', res)
            return res
        }
    },

}

export default notice